module.exports = __webpack_public_path__ + "files/c530aa57b5f314d1a22c231183e6509b.png";